module.exports = __webpack_public_path__ + "static/media/foodindustry.b2b23c41.jpg";